import { connect } from 'react-redux'
import at from 'lodash/at'
import debounce from 'lodash/debounce'

import { replace } from 'react-router-redux'

import WorkOrdersCreateEdit from '../../components/work-orders/work-orders-create-edit'
import humps from 'humps'
import moment from 'moment'
import 'moment-timezone'

import { fetchWorkOrder, updateWorkOrder } from '../../actions/work-orders'
import { fetchTechniciansForLocationWithAllocation, fetchTechniciansForCurrentLocationWithAllocation } from '../../actions/technicians'
import { loadLocations } from '../../actions/locations'
import { fetchContractsForLocation } from '../../actions/contracts'

const mapStateToProps = (state, props) => {
  const workOrder = state.workOrders[props.params.workOrderId]

  if (!workOrder) return { loading: true }

  return {
    modalTitle: 'Edit Work Order',
    submitButtonText: 'Update',
    useAllLocations: true,
    locations: state.allLocations,
    technicians: at(state.users, state.technicians),
    showAutoRenew: false,
    canShowInputted: state.allLocations[workOrder.location].showInputtedWorkOrders,
    backlog: workOrder.backlog,
    initialValues: {
      locationId: workOrder.location,
      contact: workOrder.contact,
      contactPhone: workOrder.contactPhone,
      startsAt: workOrder.startsAt,
      endsAt: workOrder.endsAt,
      description: workOrder.description,
      technicianIds: workOrder.technicians,
      showInputted: workOrder.showInputted
    },

    getLocationContact (locationId) {
      return state.allLocations[locationId].mainContact || workOrder.contact || ''
    },

    getLocationContactPhone (locationId) {
      return state.allLocations[locationId].mainContactPhone || ''
    },

    getLocationDefaultWorkOrderDescription (locationId) {
      return state.allLocations[locationId].defaultWorkOrderDescription || ''
    },

    getLocationContracts (locationId) {
      if (!state || !locationId) return null
      return at(state.contracts, state.allLocations[locationId].contracts || [])
    },

    getLocationCanShowInputted (locationId) {
      return state.allLocations[locationId].showInputtedWorkOrders || false
    }
  }
}

const mapDispatchToProps = (dispatch, props) => {
  dispatch(fetchWorkOrder(props.params.workOrderId))
    .then(() => dispatch(fetchTechniciansForCurrentLocationWithAllocation(props.params.workOrderId)))
  dispatch(loadLocations())

  let locationId, dateRange
  const debouncedSearch = debounce(
    () => {
      dispatch(fetchTechniciansForLocationWithAllocation(locationId, dateRange))
    }
    , 750
  )

  return {
    fetchTechniciansForLocationWithAllocation (_locationId, _dateRange) {
      locationId = _locationId
      dateRange = _dateRange
      debouncedSearch()
    },

    fetchContractsForLocation (locationId) {
      dispatch(fetchContractsForLocation(locationId))
    },

    onSubmit (formData) {
      const formattedData = {
        ...formData,
        startsAt: moment(formData.startsAt).toISOString(),
        endsAt: moment(formData.endsAt).toISOString(),
        timezone: moment.tz.guess()
      }

      return dispatch(updateWorkOrder(props.params.workOrderId, humps.decamelizeKeys(formattedData)))
        .then((action) => {

          if (action) {
            return action.error && Promise.reject({ _error: action.payload.errors[0] })
          } else {
            return false
          }
        })
        .then(action => dispatch(replace(`/work-orders/${props.params.workOrderId}/details`)))
    },

    handleClose () {
      dispatch(replace(`/work-orders/${props.params.workOrderId}/details`))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrdersCreateEdit)



// WEBPACK FOOTER //
// ./src/containers/work-orders/work-orders-edit-container.js